// The answer sheet on a task card is one field: a click on its blank paper
// (around the picks, beside the note, along its foot) puts the cursor in its
// note, as a click anywhere in a text field would. A click on a control, or
// one that ends a text selection, is left alone.

const SHEET = ".paper-answer-sheet"
const CONTROL = "a, button, input, textarea, select, label, summary, [contenteditable], [role='button'], [tabindex]"

export function noteToFocus(target) {
  const sheet = target?.closest?.(SHEET)
  if (!sheet || target.closest(CONTROL)) return null

  const note = sheet.querySelector(".answer-sheet__note textarea") || sheet.querySelector("textarea")
  return note && !note.disabled && !note.readOnly ? note : null
}

export function attachAnswerSheetFocus(doc = document) {
  const win = doc.defaultView || window
  if (win.__answerSheetFocusAttached) return
  win.__answerSheetFocusAttached = true

  doc.addEventListener("click", (event) => {
    if (event.defaultPrevented || event.button !== 0) return
    if (win.getSelection?.()?.isCollapsed === false) return

    const note = noteToFocus(event.target)
    if (!note) return
    note.focus()
    note.setSelectionRange?.(note.value.length, note.value.length)
  })
}
